import { DateTime } from 'luxon'

export function makeFormatters(locale: string) {
  return {
    weekday: (dt: DateTime) =>
      dt.setLocale(locale).toLocaleParts({ weekday: 'short', day: 'numeric' }),
    time: (dt: DateTime) =>
      dt.setLocale(locale).toLocaleString(DateTime.TIME_SIMPLE),
    date: (dt: DateTime) =>
      dt.setLocale(locale).toLocaleString(DateTime.DATE_MED),
    dateWeekday: (dt: DateTime) =>
      dt.setLocale(locale).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY),
    dateTime: (dt: DateTime) =>
      dt.setLocale(locale).toLocaleString(DateTime.DATETIME_MED),
    shiftRange: (start: DateTime, end: DateTime) => {
      const s = start.setLocale(locale)
      const e = end.setLocale(locale)
      return `${s.toLocaleString(DateTime.TIME_SIMPLE)} - ${e.toLocaleString(DateTime.TIME_SIMPLE)}`
    },
    zoneLabel: (dt: DateTime) => dt.setLocale(locale).toFormat('ZZZZ'),
    /** The shortest time that still reads, for a chip: `7a`, `7:30a`, `3p` */
    timeCompact: (dt: DateTime) => {
      const d = dt.setLocale(locale)
      const hour = d.toFormat(d.minute === 0 ? 'h' : 'h:mm')
      return `${hour}${d.hour < 12 ? 'a' : 'p'}`
    },
  }
}
